<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- Entity -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Workflow Templates*</mat-label>
      <mat-select formControlName="flowTemplate">
        <mat-option *ngFor="let flowTemplate of flowTemplates"
                    [value]="flowTemplate.Id">
          {{ flowTemplate.Title }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="inputForm.controls['flowTemplate'].hasError('required')">
        FlowTemplate is required!
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Fiscal Years Under Audit -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Reference*</mat-label>
      <input #title formControlName="reference" matInput placeholder="Reference*" type="text">
      <mat-error *ngIf="inputForm.controls['reference'].hasError('required')">
        Reference is required!
      </mat-error>
    </mat-form-field>
  </div>

</form>
